import sourceTypes from '../constants/sourceTypes'
import { SourceType } from '../types/core'

export const defaultSourceType: SourceType = sourceTypes[0]

export const sourceTypeById = (id: string): SourceType | undefined => {
  return sourceTypes.find((type) => type.id === id)
}

export const topSourcesTypeById = (id: string): SourceType | undefined => {
  return sourceTypes.slice(0, 3).find((type) => type.id === id)
}

export const dropdownSourceTypeById = (id: string): SourceType | undefined => {
  const dropdownSourceTypes = sourceTypes.slice(3)
  return dropdownSourceTypes.find((type) => type.id === id)
}

export const sourceTypeByApiAlias = (apiAlias: string): SourceType | undefined => {
  return sourceTypes.find((type) => type.apiAlias === apiAlias)
}

export const validateUrlSourceType = (sourceType: string, isExact: boolean): boolean => {
  return !!sourceTypeById(sourceType) && isExact
}

export const getSourceTypeName = (sourceType) =>
  sourceTypeById(sourceType)?.name || sourceType
